module.exports = __webpack_public_path__ + "assets/grey_check_mark-909113.svg";